/** @jsx h */
import h from '../../../components/Database/utils/hyperscript';
export default h("database", {
  title: "All pitches"
}, h("columns", null, h("column", {
  key: "name",
  name: "Name",
  type: "name"
}), h("column", {
  key: "categories",
  name: "Categories",
  type: "multi-select"
}, h("option", {
  key: "engagement"
}), h("option", {
  key: "revenue"
}), h("option", {
  key: "quality"
}), h("option", {
  key: "virality"
}), h("option", {
  key: "growth"
}), h("option", {
  key: "collaboration"
}), h("option", {
  key: "tech-only"
}), h("option", {
  key: "activation"
}), h("option", {
  key: "simplicity"
}), h("option", {
  key: "editor"
})), h("column", {
  key: "status",
  name: "Status",
  type: "multi-select"
}, h("option", {
  key: "shaped",
  bgColor: "#CFFCD6",
  textColor: "#38794E"
}), h("option", {
  key: "not shaped",
  bgColor: "#FFE6CC",
  textColor: "#974E00"
}), h("option", {
  key: "in review",
  bgColor: "#D4F4F7",
  textColor: "#30767E"
}), h("option", {
  key: "in progress",
  bgColor: "#FFF3C2",
  textColor: "#974E00"
})), h("column", {
  key: "creator",
  name: "Creator",
  type: "created-by"
}), h("column", {
  key: "state",
  name: "State",
  type: "select"
}, h("option", {
  key: "reviewed",
  bgColor: "#D4F4F7",
  textColor: "#30767E"
}), h("option", {
  key: "new",
  bgColor: "#CFFCD6",
  textColor: "#38794E"
}))), h("records", null, h("record", {
  createdBy: "mike"
}, h("name", null, "Example Pitch")), h("record", {
  createdBy: "mike"
}, h("name", null, "Simple analytics"), h("categories", {
  options: {
    engagement: true,
    revenue: true
  }
}), h("status", {
  options: {
    shaped: true
  }
}), h("state", {
  options: {
    reviewed: true
  }
})), h("record", {
  createdBy: "clara"
}, h("name", null, "Template improvements"), h("categories", {
  options: {
    engagement: true,
    quality: true
  }
}), h("status", {
  options: {
    'not shaped': true
  }
}), h("state", {
  options: {
    reviewed: true
  }
})), h("record", {
  createdBy: "rob"
}, h("name", null, "Finalise channel home"), h("categories", {
  options: {
    quality: true
  }
}), h("status", {
  options: {
    'in review': true
  }
}), h("state", {
  options: {
    "new": true
  }
})), h("record", {
  createdBy: "mike"
}, h("name", null, "Guest users"), h("categories", {
  options: {
    virality: true,
    growth: true,
    collaboration: true
  }
}), h("status", {
  options: {
    'in review': true
  }
}), h("state", {
  options: {
    reviewed: true
  }
})), h("record", {
  createdBy: "adrien"
}, h("name", null, "Guest users on notes"), h("categories", {
  options: {
    virality: true,
    growth: true,
    collaboration: true
  }
}), h("status", {
  options: {
    'in progress': true
  }
}), h("state", {
  options: {
    "new": true
  }
})), h("record", {
  createdBy: "antoine"
}, h("name", null, "Deep link in desktop"), h("categories", {
  options: {
    quality: true
  }
}), h("status", {
  options: {
    shaped: true
  }
}), h("state", {
  options: {
    "new": true
  }
})), h("record", {
  createdBy: "adrien"
}, h("name", null, "Onboarding 2.0"), h("categories", {
  options: {
    activation: true,
    simplicity: true
  }
}), h("status", {
  options: {
    shaped: true
  }
}), h("state", {
  options: {
    "new": true
  }
})), h("record", {
  createdBy: "brieuc"
}, h("name", null, "Zapier"), h("categories", {
  options: {
    quality: true,
    editor: true
  }
}), h("status", {
  options: {
    shaped: true
  }
}), h("state", {
  options: {
    "new": true
  }
})), h("record", {
  createdBy: "shahor"
}, h("name", null, "API Performance"), h("categories", {
  options: {
    'tech-only': true
  }
}), h("status", {
  options: {
    shaped: true
  }
}), h("state", {
  options: {
    reviewed: true
  }
}))));